/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { TServicesParams } from '../types/TServicesParams';

export class Services {
    static getInstanceOf<ServiceName>(
        // eslint-disable-next-line no-unused-vars
        Service: new (...args: any) => ServiceName,
        params: TServicesParams,
    ): ServiceName {
        return new Service(params);
    }
}
